import type * as React from 'react';
import { get } from '@Domain/Api';
import contactRelationshipsFetched, {
	type ContactRelationshipsFetchedAction,
	type ContactRelationshipsFetchedPayload,
} from '@Application/Beneficiaries/BeneficiaryContacts/ContactRelationships/Actions/contactRelationshipsFetched';
import contactRelationshipsFetchFailed, {
	type ContactRelationshipsFetchFailedAction,
} from '@Application/Beneficiaries/BeneficiaryContacts/ContactRelationships/Actions/contactRelationshipsFetchFailed';
import type FetchContactRelationships from '@Application/Beneficiaries/BeneficiaryContacts/ContactRelationships/Queries/FetchContactRelationships';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../../parameters';

type Actions = ContactRelationshipsFetchedAction | ContactRelationshipsFetchFailedAction;

export default (_query: FetchContactRelationships) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<ContactRelationshipsFetchedPayload>(
				`${parameters.api.host}/api/enums/contact-relationships`,
			);

			const action = contactRelationshipsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = contactRelationshipsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
